import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
import "./APIAMemberInformationForm.scss";
import { Alert } from "@mui/material";
import { devLog } from "utils/devLog";

const policyMap = new Map();
function APIAMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.memberRef);

  const [last8Vin] = useState(props.currState.MemberLookup.last8Vin);
  const [decalNumber] = useState(props.currState.MemberLookup.decalNumber);
  const [memberNumber] = useState(props.currState.MemberLookup.memberNumber);
  const [make] = useState(props.currState.MemberLookup.make);
  const [model] = useState(props.currState.MemberLookup.model);
  const [year] = useState(props.currState.MemberLookup.year);
  const [color] = useState(props.currState.MemberLookup.color);
  const [firstName] = useState(props.currState.MemberLookup.firstName);
  const [lastName] = useState(props.currState.MemberLookup.lastName);
  const [fullName] = useState(props.currState.MemberLookup.fullName);
  const [phoneNumber] = useState(props.currState.MemberLookup.phoneNumber);

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType);
  const [memberInfo, setMemberInfo] = useState(undefined);
  const [selectedContact, setSelectedContact] = useState(undefined);
  const [partnerCode, setPartnerCode] = useState(props.currState.localGroup);
  const [contacts, setContacts] = useState(undefined);

  useEffect(() => {
    // devLog(props);
    onSubmit();
  }, []);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
    }
  };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    // devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      setMemberInfo(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        searchType: searchType,
        decalNumber: decalNumber,
        memberNumber: memberNumber,
        last8Vin: last8Vin,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        partnerCode: partnerCode,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        // devLog("JSON", json);
        if (typeof json.data.memberInfo === "object" && typeof json.data.memberInfo.contacts === "object") {
          if (!json.data.error) {
            setMemberInfo(json.data.memberInfo);
            setContacts(json.data.memberInfo.contacts);
            onLoad(true);
          } else {
            setMemberInfo(undefined);
            setContacts(undefined);
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.error === "object") {
          setError(json.data.error.message);
          setMemberInfo(undefined);
          setContacts(undefined);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setError(t("APIA.PolicyInformation.UnableToFindMember"));
          policyMap.delete(searchValue);
          setMemberInfo(undefined);
          setContacts(undefined);
          onLoad(false);
        }
        setLoading(false);
      })

      //Lookup: Failed
      .catch((e) => {
        setMemberInfo(undefined);
        setContacts(undefined);
        devLog("error", e);
        setLoading(false);
        setError(t("APIA.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };
  const onUserBack = (e) => {
    e.preventDefault();
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const onSelect = (contact) => {
    // devLog("onSelect", contact);
    setSelectedContact(contact);
    if (!contact) {
      return;
    }
    if (typeof props.onSelect === "function") {
      props.onSelect(memberInfo, contact);
    }
  };

  return (
    <>
      <div className="formContainer">
        {memberInfo && !error ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.ContractInformationHeader4")}</h4>
              <hr />
              <div className="policy-info-line">
                <b>{t("APIA.PolicyInformation.ConfirmCustomerYear")}:</b> {memberInfo.year}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("APIA.PolicyInformation.ConfirmCustomerMake")}:</b> {memberInfo.make}
              </div>

              <hr />
              <div className="policy-info-line">
                <b>{t("APIA.PolicyInformation.ConfirmCustomerModel")}:</b> {memberInfo.model}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("APIA.PolicyInformation.ConfirmCustomerColor")}:</b> {memberInfo.color}
              </div>
              <hr />
            </div>

            {contacts && !error ? (
              <>
                <div className="vehicleHeader">
                  <h4 className="slim">{t("BWC.PolicyInformation.MemberInformationHeader2")}</h4>
                </div>
                <div className="vehicle-list-container">
                  {contacts.map((contact, index) => {
                    return (
                      <>
                        <div
                          key={index}
                          value={contact}
                          className={`vehicle-list-item ${selectedContact === contact ? "selected" : ""}`}
                          onClick={(e) => {
                            onSelect(contact);
                          }}
                        >
                          <div value={contact} className="vehicle-list-item-col-1">
                            <h5 value={contact}>
                              {contact.firstName} {contact.lastName}
                            </h5>
                          </div>
                          <input
                            className="vehicleSelector"
                            type="radio"
                            name="policy-vehicle"
                            checked={selectedContact === contact ? "selected" : ""}
                          />
                        </div>
                      </>
                    );
                  })}
                </div>
              </>
            ) : (
              <></>
            )}
            {props.showError && <Alert severity="error">{t("description.SelectMemberAlert")}</Alert>}
          </div>
        ) : (
          <></>
        )}{" "}
      </div>
      {error ? (
        <div className="errorSection">
          <b className="error">{error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              {t("description.TryAgain")}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleARI`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}

export default APIAMemberInformationForm;
